export default __webpack_public_path__ + "static/media/barrier.79fef045.svg";